import React from 'react';
import PainPointCard from './PainPointCard';
import WarningIcon from '@mui/icons-material/Warning';

interface PainPointsSectionProps {
  painPoints: Array<{
    Area: string;
    PainPoint: string;
    Remediation: string;
  }>;
}

const PainPointsSection: React.FC<PainPointsSectionProps> = ({ painPoints }) => {
  if (!painPoints || painPoints.length === 0) {
    return null;
  }

  return (
    <div style={{
      background: '#fff',
      borderRadius: '12px',
      padding: '2rem',
      //marginBottom: '1.5rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      borderLeft: '4px solid #e53e3e',
      breakInside: 'avoid'
    }}>
      <h2 style={{ 
        color: '#e53e3e', 
        fontSize: '1.5rem', 
        fontWeight: '600',
        marginBottom: '1rem'
      }}>
        <WarningIcon style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} /> Pain Points
      </h2>
      {painPoints.map((point, index: number) => (
        <PainPointCard 
          key={index} 
          point={point} 
          index={index} 
        />
      ))}
    </div>
  );
};

export default PainPointsSection;
